<ng-container *ngIf="organization">
  <i class="fas fa-user me-1" i18n-title="@@resource.status.line.users" title="Users"></i>{{usersCount$ | async}}
  <i class="fas fa-th-large ms-3 me-1" i18n-title="@@projects" title="Projects"></i>{{projectsCount$ | async}}
</ng-container>
<ng-container *ngIf="project">
  <i class="fas fa-book me-1" i18n-title="@@collection" title="Table"></i>{{collectionsCount$ | async}}
  <i class="fas fa-file-alt ms-3 me-1" i18n-title="@@records" title="Records"></i>{{documentsCount$ | async}}
</ng-container>
